import { Image, Text, Button } from "@fluentui/react-components";
import * as React from "react";
import { useIntl } from "react-intl";
import { useNavigate, useLocation } from "react-router-dom";

import { Flex } from '@tdp/common/fluentV9MigrationComponents';

export const PageNotFound: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  const message = intl.formatMessage({
    defaultMessage: 'The page you are looking for does not exist.',
    description: 'Message displayed when a user navigates to a non-existent page',
  });
  const clickButtonText = intl.formatMessage({
    defaultMessage: 'Go to Home',
    description: 'Button text to navigate back to the home page from not found page',
  });

  const onButtonClick = () => {
    navigate("/home");
  };

  return (
    <Flex fill column vAlign="center" hAlign="center" gap="gap.medium">
      <Image src='/images/not-found/not-found-image.png' alt="Not Found" />
      <Text>{message}</Text>
      <Text>{location.pathname}</Text>
      <Button onClick={onButtonClick}>{clickButtonText}</Button>
    </Flex>
  );
};
